module.exports = __webpack_public_path__ + "static/media/white-check.c564ad49.svg";